import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { Observable } from 'rxjs';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { ViewService } from '../../view.service';

@Component({
  selector: 'app-view-labels',
  templateUrl: './view-labels.component.html',
  styleUrls: ['./view-labels.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewLabelsComponent implements OnInit {
  @Select(StoryLabelsState.getChapterLabels)
  labels$: Observable<LabelModel[]>;

  @Select(StoryLabelsState.getSelectedLabel)
  selectedLabel$: Observable<LabelModel>;


  constructor(
    private viewService: ViewService
  ) { }

  ngOnInit() {
  }

  handleLabelClick(label: LabelModel) {
    this.viewService.selectLabel(label, true);
  }

}
